<label class="tg" [class.is-disabled]="disabled">
  <input
    type="checkbox"
    role="switch"
    class="tg__input"
    [checked]="checked"
    [disabled]="disabled"
    [attr.aria-checked]="checked"
    [attr.aria-label]="label || null"
    (change)="onChange($event)"
  />
  <span class="tg__track" aria-hidden="true">
    <span class="tg__knob"></span>
  </span>
</label>
